// --------------------------------------------------------------------------------------------------------
export class EmailValidation {
    SubscriptionKey: string;
    Email: string;
    EmailValidated: boolean;
    PEC: string;
    DefaultEmail: DefaultEmail;
    Cc: string;
    Bcc: string;
    AWSRegion: string;
    IsDefault: boolean;

    constructor() {
        this.Email = '';
        this.Cc = '';
        this.Bcc = '';
        this.PEC = '';
        this.EmailValidated = false;
        this.IsDefault = false;
        this.SubscriptionKey = '';
        this.DefaultEmail = DefaultEmail.None;
    }
}

export enum DefaultEmail {
    None = -1,
    Email = 0,
    PEC = 1,
}
